import { Pipe, PipeTransform, inject } from '@angular/core';
import { LabelService } from '../../services/label/label.service';

// Impure pra refletir mudancas de empresa selecionada sem precisar de
// subscribe nos componentes. Lookup eh sincrono e O(1), sem custo material.
@Pipe({ name: 'label', pure: false })
export class LabelPipe implements PipeTransform {
  private labelService = inject(LabelService);
  transform(key: string): string {
    return this.labelService.get(key);
  }
}
